import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";

const Create = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const metaTypeList = [
		{ name: "الرئيسية", value: "home" },
		{ name: "من نحن", value: "about" },
		{ name: "خدماتنا", value: "services" },
		{ name: "الباقات", value: "packages" },
		{ name: "معرض الأعمال", value: "projects" },
		{ name: "المدونة", value: "blog" },
		{ name: "اتصل بنا", value: "contact" },
		{ name: "الباقات", value: "packages" },
		{ name: "سياسة الموقع", value: "privacy" },
		{ name: "خريطة الموقع", value: "sitemap" },
		{ name: "الشروط والأحكام", value: "terms" },
	];

	const [metaNameAr, setMetaNameAr] = useState("");
	const [metaNameEn, setMetaNameEn] = useState("");
	const [metaContentAr, setMetaContentAr] = useState("");
	const [metaContentEn, setMetaContentEn] = useState("");
	const [metaType, setMetaType] = useState("");
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة سيو جديد",
				breadcrumb: "سيو",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	const handleSubmit = e => {
		e.preventDefault();

		if (
			!metaNameAr ||
			!metaNameEn ||
			!metaContentAr ||
			!metaContentEn ||
			!metaType
		) {
			return toast.error("جميع البيانات مطلوبة");
		}

		const data = {
			name: {
				ar: metaNameAr,
				en: metaNameEn,
			},
			content: {
				ar: metaContentAr,
				en: metaContentEn,
			},
			type: metaType,
		};
		axios
			.post(`${process.env.REACT_APP_API_URL}/metadataTags`, data, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				history.push("/seo/index");
				toast.success("تم اضافة السيو بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div
					className="card"
					style={{
						padding: "30px 30px 0",
					}}
				>
					<div className="row">
						<div className="form-item col-md-6">
							<label>عنوان الميتا ( عربي )</label>
							<input
								type="text"
								value={metaNameAr}
								onChange={e => setMetaNameAr(e.target.value)}
							/>
						</div>

						<div className="form-item col-md-6">
							<label>عنوان الميتا ( انجليزي )</label>
							<input
								type="text"
								value={metaNameEn}
								onChange={e => setMetaNameEn(e.target.value)}
							/>
						</div>

						<div className="form-item col-md-6">
							<label>وصف الميتا ( عربي )</label>
							<input
								type="text"
								value={metaContentAr}
								onChange={e => setMetaContentAr(e.target.value)}
							/>
						</div>

						<div className="form-item col-md-6">
							<label>وصف الميتا ( انجليزي )</label>
							<input
								type="text"
								value={metaContentEn}
								onChange={e => setMetaContentEn(e.target.value)}
							/>
						</div>

						<div className="form-item col-md-12">
							<label>نوع الميتا</label>
							<select
								value={metaType}
								onChange={e => setMetaType(e.target.value)}
							>
								<option value={""}>{"اختر نوع الميتا"}</option>
								{metaTypeList?.map((item, index) => (
									<option key={index} value={item.value}>
										{item.name}
									</option>
								))}
							</select>
						</div>
						<div className="col-md-12">
							<div className="form-item  ">
								<button className="bt bt-success btn-block">ارسال</button>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default Create;
